import { ModalService } from 'src/app/shared/services/modal.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-shipments-modal',
  templateUrl: './shipments-modal.component.html',
  styleUrls: ['./shipments-modal.component.scss']
})
export class ShipmentsModalComponent implements OnInit {

  constructor(private _modalService: ModalService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  public closeModal() {
    this._modalService.close()
  }
}
